import LessonSummaryRatingApiUtils from '../utils/api/lessonSummaryRating';
import { addMessage as addModalMessage } from './modal';

export const CREATE_LESSON_SUMMARY_RATING_SENT =
  'CREATE_LESSON_SUMMARY_RATING_SENT';
export const CREATE_LESSON_SUMMARY_RATING_SUCCEEDED =
  'CREATE_LESSON_SUMMARY_RATING_SUCCEEDED';
export const CREATE_LESSON_SUMMARY_RATING_FAILED =
  'CREATE_LESSON_SUMMARY_RATING_FAILED';

export function createSent() {
  return { type: CREATE_LESSON_SUMMARY_RATING_SENT };
}

export function createSucceeded(data) {
  return {
    type: CREATE_LESSON_SUMMARY_RATING_SUCCEEDED,
    payload: data,
  };
}

export function createFailed(error) {
  return { type: CREATE_LESSON_SUMMARY_RATING_FAILED };
}

export function create(summaryId, rate) {
  return (dispatch) => {
    dispatch(createSent());
    return LessonSummaryRatingApiUtils.create(summaryId, rate).then(
      (data) => {
        dispatch(
          addModalMessage('Successfully rated the summary.', {
            type: 'success',
            autoDisappear: true,
          }),
        );
        dispatch(createSucceeded(data));
      },
      (error) => {
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: true,
            type: 'error',
          }),
        );
        dispatch(createFailed(error));
      },
    );
  };
}
